module.exports = __webpack_public_path__ + "static/f68cd50963de98b6ec37af3431299542750fda9f82bfb956b22fbd546894fbcf-c9dda2f411d12c2bdfdaa385500579d9.png";